// Alignment types for the system
export const ALIGNMENT_TYPES = {
  OBJECT_TO_OBJECT: 'object_to_object',
  CANVAS_CENTER: 'canvas_center',
  DISTRIBUTE: 'distribute',
  SPACING: 'spacing',
};

// Alignment edge types
export const ALIGNMENT_EDGES = {
  LEFT: 'left',
  RIGHT: 'right',
  TOP: 'top',
  BOTTOM: 'bottom',
  CENTER_HORIZONTAL: 'centerHorizontal',
  CENTER_VERTICAL: 'centerVertical',
};

// Alignment line types for visualization
export const ALIGNMENT_LINE_TYPES = {
  EDGE: 'edge',
  CENTER: 'center',
  SPACING: 'spacing',
  DISTRIBUTE: 'distribute',
};

// Default alignment configuration
// Note: These are now defined in editorConfig.snapSettings
// This is kept for backward compatibility but values from editorConfig take precedence
export const DEFAULT_ALIGNMENT_CONFIG = {
  // Distance thresholds
  alignmentTolerance: 30, // Distance at which alignment lines appear
  snapThreshold: 5, // Distance at which objects snap to alignment
  distanceMeasurementThreshold: 300, // Distance at which distance measurements appear

  // Visual configuration
  lineColor: 'rgba(169, 96, 211, 0.35)', // Light purple for alignment lines
  snapIndicatorColor: '#ff6b00', // Orange for active snap indication
  lineWidth: 1,
  lineOffset: 5, // Extra length added to alignment lines beyond objects

  // Feature toggles
  showAlignmentLines: true,
  enableObjectAlignment: true,
  enableCenterAlignment: true,
  enableEdgeAlignment: true,
  enableCanvasEdgeAlignment: true,
  showDistanceMeasurements: false, // Distance measurements disabled by default
};
